import {FlywheelComponent} from '#lit/lib/component.js';
import type {CSSResultArray} from 'lit';
import {html} from 'lit';
import {repeat} from 'lit/directives/repeat.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import sanitize from 'sanitize-html';
import {Size as FlyIconSize} from '#lit/components/base/icon/index.js';
import {customElement, property} from 'lit-element';
import styles from './style.scss';
import {
  DEFAULT_ALLOWED_HTML_TAG_ATTRIBUTES_FOR_ERROR_MESSAGES,
  DEFAULT_ALLOWED_HTML_TAGS_FOR_ERROR_MESSAGES,
} from '#lit/common/constants/security.js';

interface SanitizeOptions {
  allowedTags?: string[];
  allowedAttributes?: {[key: string]: string[]};
}

export const COMPONENT_TAG = 'fly-form-errors-banner';

@customElement(COMPONENT_TAG)
export class FlyFormErrorsBanner extends FlywheelComponent {
  @property({type: Object})
  errors: Set<string> = new Set();

  @property({type: Object})
  sanitizeOptions: SanitizeOptions = {
    allowedTags: DEFAULT_ALLOWED_HTML_TAGS_FOR_ERROR_MESSAGES,
    allowedAttributes: DEFAULT_ALLOWED_HTML_TAG_ATTRIBUTES_FOR_ERROR_MESSAGES,
  };

  static get styles(): CSSResultArray {
    return [styles];
  }

  render() {
    return html`
      <div class="banner banner--error">
        <div class="banner__aside">
          <div class="banner__icon">
            <fly-icon size=${FlyIconSize.LG} icon="highlight_off"></fly-icon>
          </div>
        </div>
        <div class="banner__main">
          <div class="banner__title">Error</div>
          <ul class="banner__content">
            ${repeat(
              this.errors,
              error => error,
              (error: string) =>
                html`<li>
                  ${unsafeHTML(sanitize(error, this.sanitizeOptions))}
                </li>`
            )}
          </ul>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_TAG]: FlyFormErrorsBanner;
  }
}
